import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { useShop } from '../../../Providers/ShopProvider';

const useGetParamsFromUrl = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const params = new URLSearchParams(location.search)
    const { setProductsFilter, setActiveCategory } = useShop()

    useEffect(() => {
        let query = params.get('q')
        let cat = params.get('cat') || 0

        setProductsFilter(prev => ({
            ...prev,
            SearchingQuery: query,
            ActiveCatNodeId: Number(cat)
        }))

        let tmpCatObject = cat != 0 ? { nodeId: cat } : null
        if (!tmpCatObject) {
            setActiveCategory(null)
            localStorage.setItem("categoryNavigationTree", JSON.stringify(null))
        }
        setActiveCategory(tmpCatObject)
    }, [location.search])

    const handleClearQuery = () => {
        params.delete('q')
        const newSearch = params.toString()
        navigate(newSearch ? `/shop?${newSearch}` : `/shop`)
    }

    return { handleClearQuery }
}

export default useGetParamsFromUrl